export type VideoPlayer = (typeof videoPlayers)[number]

export const videoPlayers = [
  'adplayerproVideoProvider',
  'jwplayerVideoProvider',
  'videojsVideoProvider',
] as const
